<template>
    <div :class="{busy: cartIsBusy}">
        <template v-if="hasVariations">
            <template v-if="canBeBought">
                <template v-if="!$scope.IS_REGULAR_CUSTOMER && (product.type || {}).id === 15">
                    <ProductWholesalerSingleSize
                        v-model="wholesalerSizesQuantitiesToBuy"
                        :product="product"/>
                </template>
                <template v-else-if="!$scope.IS_REGULAR_CUSTOMER">
                    <ProductWholesalerMultipleSizes
                        v-model="wholesalerSizesQuantitiesToBuy"
                        :product="product"
                        class="mb"
                        @show-sizes-table="$emit('show-sizes-table')"/>
                </template>
                <template v-else>
                    <ProductVariationsOld
                        v-model="sizeToBuy"
                        :product="product"
                        :show-reprint-message="hasStockAvailable && showReprintMessage"
                        :shop-mode="true"
                        @reprint="showReprintModalForSelectedSize"/>
                </template>
            </template>

            <Alert v-if="alert" :alert="alert"/>

            <div v-if="!canBeBought" class="alert-danger mb text-center">
                Produto Indisponível
            </div>
            <div v-else-if="hasStockAvailable">
                <div id="product-buy-button-container"
                     class="mt mb-3"
                     :style="$scope.IS_REGULAR_CUSTOMER ? null : 'justify-content: center'">
                    <template v-if="!$scope.IS_REGULAR_CUSTOMER">
                        <ProductWholesalerSizesSummary
                            v-if="wholesalerSizesQuantitiesToBuy"
                            class="mr-auto"
                            :variations="product.variations"
                            :wholesaler-sizes-quantities-to-buy="wholesalerSizesQuantitiesToBuy"/>
                        <span class="hidden-xs-up mt-2" style="width: 100%"/>
                    </template>
                    <ProductBuyButton
                        ref="buyButton"
                        :product="product"
                        :size-to-buy="sizeToBuy"
                        :is-size-unavailable="showReprintMessage"
                        :text="$scope.IS_REGULAR_CUSTOMER ? 'Comprar' : 'Adicionar à sacola'"
                        :wholesaler-sizes-quantities-to-buy="wholesalerSizesQuantitiesToBuy"
                        @done="reset"/>
                    <div id="product-alerts" v-if="$scope.IS_REGULAR_CUSTOMER">
                        <p class="text-yanone text-info mt-0 mb-1" v-if="visitAlertMessage">
                            <i class="icon-cr icon-eye-open"></i> &nbsp;{{ visitAlertMessage }}
                        </p>
                        <ProductAdvantages class="text-yanone"/>
                    </div>
                </div>
            </div>
            <button v-else class="btn btn-wide" @click="showReprint = true">
                Receber aviso quando voltar ao estoque
            </button>
        </template>
        <NewsletterSubscriber v-else v-slot="subscriber">
            <form class="frame text-left" :class="{busy: subscriber.busy}">
                <p>Este produto não se encontra disponível em nosso catálogo.</p>
                <p>
                    Mas você pode informar seu email logo abaixo para se cadastrar na nossa
                    newsletter e receber novidades, lançamentos e promoções:
                </p>
                <TextField label="Nome:" autocomplete="name"
                           type="text" v-model="subscriber.fields.name"/>
                <TextField label="Email:" placeholder="nome@email.com" autocomplete="email"
                           type="email" v-model="subscriber.fields.email"/>
                <LoadingButton class="btn btn-wide mt" @click="subscriber.subscribe"
                               :loading="subscriber.busy">
                    Assinar
                </LoadingButton>
            </form>
        </NewsletterSubscriber>

        <div id="product-price-fixed"
             v-if="$scope.IS_REGULAR_CUSTOMER && hasStockAvailable && hasVariations"
             class="text-yanone hidden-xs-up"
             :class="{visible: showFixedFrame}">
            <ProductPagePrice :product="product"/>
            <ProductBuyButton
                :product="product"
                :size-to-buy="sizeToBuy"
                :is-size-unavailable="showReprintMessage"
                :wholesaler-sizes-quantities-to-buy="wholesalerSizesQuantitiesToBuy"
                @request-size="scrollToBuy"/>
        </div>
    </div>
</template>

<script>
    import ProductReprint from "./ProductReprint";
    import {readCookie} from "../../../common/common";
    import ProductWishlist from "./ProductWishlist";
    import Alert from "../common/Alert";
    import Countdown from "../common/Countdown";
    import ProductPagePrice from "./ProductPagePrice";
    import ProductBuyButton from "./ProductBuyButton";
    import throttle from "lodash/throttle";
    import ProductVariationsOld from "./ProductVariationsOld";
    import ProductAdvantages from "./ProductAdvantages";
    import ProductWholesalerMultipleSizes from "./ProductWholesalerMultipleSizes";
    import ProductWholesalerSingleSize from "./ProductWholesalerSingleSize";
    import LoadingButton from "../common/LoadingButton";
    import NewsletterSubscriber from "../newsletter/NewsletterSubscriber";
    import Modal from "../common/container/Modal";
    import ProductWholesalerSizesSummary from "./ProductWholesalerSizesSummary";
    import {cartStore} from "../../common/store/cart-store";
    import {productStore} from "../../common/store/product-store";
    import TextField from "@bit/chicorei.chicomponents.input.text-field"
    import SelectField from "@bit/chicorei.chicomponents.input.select-field";

    export default {
        name: "ProductBuy",

        components: {
            ProductWholesalerSizesSummary,
            LoadingButton,
            TextField,
            NewsletterSubscriber,
            ProductWholesalerSingleSize,
            ProductWholesalerMultipleSizes,
            ProductVariationsOld,
            ProductBuyButton,
            ProductPagePrice,
            Countdown,
            Alert,
            ProductReprint,
            ProductWishlist,
            ProductAdvantages,
            Modal,
            SelectField
        },

        props: {
            canBeBought: {
                type: Boolean,
                required: true
            },
        },

        data() {
            return {
                productStoreState: productStore.state,

                showFixedFrame: false,
                alert: null,
                cartStoreState: cartStore.state
            }
        },

        computed: {
            product() {
                return this.productStoreState.product;
            },

            sizeToBuy: {
                get() {
                    return this.productStoreState.sizeToBuy
                },

                set(val) {
                    this.productStoreState.sizeToBuy = val
                }
            },

            sizeToReprint: {
                get() {
                    return this.productStoreState.sizeToReprint
                },

                set(val) {
                    this.productStoreState.sizeToReprint = val
                }
            },

            showReprint: {
                get() {
                    return this.productStoreState.showReprint;
                },

                set(val) {
                    this.productStoreState.showReprint = val
                }
            },

            wholesalerSizesQuantitiesToBuy: {
                get() {
                    return this.productStoreState.wholesalerSizesQuantitiesToBuy
                },

                set(val) {
                    this.productStoreState.wholesalerSizesQuantitiesToBuy = val
                }
            },

            showReprintMessage() {
                return this.$scope.IS_REGULAR_CUSTOMER
                    && this.sizeToBuy
                    && (!this.product.in_stock || (!this.sizeToBuy.virtual_stock && this.sizeToBuy.quantity === 0));
            },

            cartIsBusy() {
                return this.cartStoreState.updatingCart;
            },

            hasVariations() {
                return this.product.variations.length > 0;
            },

            stockSum() {
                return !this.product.in_stock ? 0 : this.product.variations.reduce((previous, current) => previous + current.quantity, 0);
            },

            hasStockAvailable() {
                return this.product.in_stock && (this.product.virtual_stock || this.stockSum > 0);
            },

            visitAlertMessage() {
                if (!this.product.product_views)
                    return null

                return this.product.product_views + ' pessoas visualizaram este produto recentemente';
            }
        },

        watch: {
            sizeToBuy(to) {
                if (to && (!this.product.in_stock || (!to.virtual_stock && to.quantity === 0))
                    && (this.product.type || {}).id !== 15) {
                    this.sizeToReprint = to;
                    this.showReprint = true;
                    this.sizeToBuy = null;
                }
            },
        },

        created() {
            this.sendPageView();
        },

        mounted() {
            this.updateFixedFrameVisibility();
            window.addEventListener('scroll', throttle(() => this.updateFixedFrameVisibility(), 500));
        },

        methods: {
            updateFixedFrameVisibility() {
                if (this.canBeBought && this.hasStockAvailable && this.$refs.buyButton) {
                    this.showFixedFrame = this.$refs.buyButton.$el.getBoundingClientRect().top < 0;
                } else {
                    this.showFixedFrame = false;
                }
            },

            sendPageView() {
                if (!readCookie('_ga') && !this.$scope.id) return;
                this.axios.api.post('/hooks/customers/products/view', {product_id: this.product.id});
            },

            scrollToBuy() {
                cr$.byEl(this.$refs.productBuyAnchor).scrollIntoView();
            },

            reset() {
                this.wholesalerSizesQuantitiesToBuy = {};
            },

            showReprintModalForSelectedSize() {
                this.sizeToReprint = this.sizeToBuy;
                this.showReprint = true;
            }
        }
    }
</script>